import React, { useEffect, useState } from 'react';
import { Button, Modal, Form as Forms } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
    Select,
} from '../../../../../../_metronic/_partials/controls';

import * as requestBank from '../../../../MasterData/_redux/bank/bankCrud';
import { getDepartmentNotDeleted } from '../../../../MasterData/_redux/department/departmentCrud';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

const UploadFileSchema = Yup.object().shape({
    channel_uuid: Yup.string().required('Kode Rekening wajib diisi'),
    file: Yup.mixed().required('File Wajib diisi'),
});

export function BankKurbanForm({ saveUpload, onHide }) {

    const [bank, setBank] = useState([]);
    const [kodeRek, setKodeRek] = useState([]);
    const [department, setDepartment] = useState([])


    useEffect(() => {

        const fetchBank = async () => {
            const result = await requestBank.getBankAll();
            setBank(result.data.data);
        };
        fetchBank();

        const getDepartmentList = async () => {
            const result = await getDepartmentNotDeleted()
            setDepartment(result.data.data)
        }
        getDepartmentList()

    }, []);

    const showRekening = (event) => {
        const value = event;
        if (value === '') {
            setKodeRek([]);
        } else {
            let obj = bank.find(object => object.uuid === value);
            setKodeRek(obj.channel);
        }
    };

    let uploadfile = {
        file: undefined,
        channel_uuid: '',
    };

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={uploadfile}
                validationSchema={UploadFileSchema}
                onSubmit={(values) => {
                    // let parsedChannel = JSON.parse(values.channel_uuid)
                    // values.channel_uuid = parsedChannel.uuid
                    saveUpload(values);
                }}
            >
                {({ handleSubmit, setFieldValue, handleChange, isSubmitting, values }) => (
                    <>
                        <Modal.Body>

                            <div className="form-group row">
                                {/* Select Bank */}
                                <div className="col">
                                    {/* <Select name="bank" label="Bank" onChange={showRekening}>
                                        <option value="">--PILIH--</option>
                                        {bank.map(item =>
                                            <option key={item.uuid} value={item.uuid}>{item.name}</option>,
                                        )}
                                    </Select> */}
                                    <label>Select Bank Pengirim</label>
                                    <Autocomplete
                                        name="bank"
                                        options={bank}
                                        getOptionLabel={(option) => option.name}
                                        // defaultValue={channelFiltered.find((option) => option.uuid === values.channel_uuid)}
                                        onChange={(e, value) => {
                                            if (value) {
                                                // setSelectedAccountNumber(value)
                                                showRekening(value.uuid, setFieldValue)
                                                setFieldValue('bank', value.uuid)
                                            } else {
                                                setFieldValue('bank', "")
                                                showRekening("", setFieldValue)
                                                // setSelectedAccountNumber(value)
                                            }
                                        }}
                                        value={bank.length > 0 && bank.find((item) => item.uuid === values.bank)}
                                        // loading={LoadingAccountNumber}

                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Pilih Bank"
                                                variant="outlined"
                                                disableClearable
                                                size="small"

                                            />
                                        )}
                                    />
                                    <label>Harap Pilih <b>Bank Pengirim</b></label>
                                    <ErrorMessage name='bank'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>} />
                                </div>

                                {/* Channel UUID */}
                                <div className="col">
                                    {/* <Select
                                        name="channel_uuid"
                                        label="Kode Rekening"
                                        onChange={(e) => {
                                            let parsed = JSON.parse(e.target.value)

                                            setFieldValue('channel_uuid', e.target.value)
                                            setFieldValue('department_uuid', parsed.department_uuid)

                                        }}
                                    >
                                        <option value="">--PILIH--</option>
                                        {
                                            kodeRek.map(row =>
                                                <option key={row.uuid} value={JSON.stringify({ uuid: row.uuid, department_uuid: row.department_uuid })}>{row.name}</option>,
                                            )
                                        }
                                    </Select> */}
                                    <label>Select Kode Rekening</label>
                                    <Autocomplete
                                        name="channel_uuid"
                                        options={kodeRek}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => {
                                            if (value) {
                                                setFieldValue('channel_uuid', value.uuid)
                                                setFieldValue('department_uuid', value.department_uuid)
                                            } else {
                                                setFieldValue('channel_uuid', "")
                                                setFieldValue('department_uuid', "")
                                            }
                                        }}
                                        value={kodeRek.length > 0 && kodeRek.find((item) => item.uuid === values.channel_uuid)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Pilih Kode Rekening"
                                                variant="outlined"
                                                disableClearable
                                                size="small"

                                            />
                                        )}
                                    />
                                    <label>Harap Pilih <b>Kode Rekening</b></label>
                                    <ErrorMessage name='channel_uuid'
                                        render={msg => <div style={{ color: 'red' }}>{msg}</div>} />
                                </div>

                            </div>

                            <div className="form-group row">
                                <div className="col">
                                    <Select
                                        name="department_uuid"
                                        label="Departemen"
                                        onChange={(e) => {
                                            setFieldValue('department_uuid', e.target.value)
                                        }}
                                    >
                                        <option value="">Pilih</option>
                                        {
                                            department.map(row =>
                                                <option key={row.code} value={row.uuid}>{row.name}</option>,
                                            )
                                        }
                                    </Select>
                                </div>

                            </div>

                            <div className="form-group row">
                                {/* File */}
                                <div className="col-lg-8">
                                    <Forms.Group>
                                        <Forms.File

                                            id="BankUploadForm" label="Bank File" onChange={(event) => {
                                                setFieldValue('file', event.currentTarget.files[0]);
                                            }} />
                                        <ErrorMessage name='file'
                                            render={msg => <div style={{ color: 'red' }}>{msg}</div>} />
                                    </Forms.Group>

                                </div>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>

                            <Button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate"
                            >
                                Close
                            </Button>
                            <Button
                                type="submit"
                                onClick={() => handleSubmit()}
                                disabled={isSubmitting}
                                className="btn btn-primary btn-elevate"
                            >
                                Save
                            </Button>
                        </Modal.Footer>
                    </>
                )}
            </Formik>

        </>
    );
}
